/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tabs/view.blocks to change it.
import Content from './Content/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Tabs({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Home/Tabs"
  
}) {
  return (<React.Fragment
>
<Content
  viewPath={`${viewPath}/Content`}
/>
{children}
</React.Fragment>)
}